import { render, staticRenderFns } from "./History.vue?vue&type=template&id=7070487e&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"
import style0 from "./History.vue?vue&type=style&index=0&id=7070487e&prod&lang=css"
import style1 from "./History.vue?vue&type=style&index=1&id=7070487e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7070487e",
  null
  
)

export default component.exports